import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import css from "./DiscoveringYourPersonality.module.css";
import { CBMPI } from "../../Utils/CBMPI";
import { UserContext } from "../../Context/UserContext";
import { updateUserFirebase } from "../../Utils/firebaseUser";
import { ClinicContext } from "../../Context/ClinicContext";
import { CBMPIresultsPt } from "../../Utils/CBMPIresults";

export const DiscoveringYourPersonality = () => {
  const { userData, setUserData } = useContext(UserContext);
  const { step, setStep } = useContext(ClinicContext);
  const CBMPIarr = new Array(42);
  for (let i = 0; i < CBMPIarr.length; i++) {
    CBMPIarr[i] = new Array(5).fill(false);
  }
  const [CBMPICheck, setCBMPICheck] = useState(CBMPIarr);
  const [completeCBMPI, setCompleteCBMPI] = useState(0);
  const [detailsModal, setDetailsModal] = useState(false);
  const navigate = useNavigate();
  const stepLength = CBMPI.length + 5;

  const traitLabels = [
    "Emocionalidade",
    "Energia",
    "Sociabilidade",
    "Cumprimento de Regras",
    "Flexibilidade Cognitiva",
    "Flexibilidade Psicológica",
  ];

  function handleCheckCBMPI(row, col) {
    let sum = completeCBMPI + 1;
    setCompleteCBMPI(sum);
    let array = [...CBMPICheck];
    if (array[row].includes(true)) {
      if (array[row][col]) {
        array[row][col] = false;
        setCBMPICheck(array);
      } else {
        let position = array[row].indexOf(true);
        array[row][position] = false;
        array[row][col] = !array[row][col];
        setCBMPICheck(array);
      }
    } else {
      array[row][col] = !array[row][col];
      setCBMPICheck(array);
    }
  }

  const handleResult = (
    emotion,
    energy,
    social,
    rules,
    abstraction,
    flexibility
  ) => {
    const text = [];
    if (emotion > 60) {
      text.push(CBMPIresultsPt.emotionHigh);
    } else if (emotion <= 60 && emotion >= 40) {
      text.push(CBMPIresultsPt.emotionModerate);
    } else if (emotion < 40) {
      text.push(CBMPIresultsPt.emotionLow);
    }
    if (energy > 60) {
      text.push(CBMPIresultsPt.energyHigh);
    } else if (energy <= 60 && energy >= 40) {
      text.push(CBMPIresultsPt.energyModerate);
    } else if (energy < 40) {
      text.push(CBMPIresultsPt.energyLow);
    }
    if (social > 60) {
      text.push(CBMPIresultsPt.socialHigh);
    } else if (social <= 60 && social >= 40) {
      text.push(CBMPIresultsPt.socialModerate);
    } else if (social < 40) {
      text.push(CBMPIresultsPt.socialLow);
    }
    if (rules > 60) {
      text.push(CBMPIresultsPt.rulesHigh);
    } else if (rules <= 60 && rules >= 40) {
      text.push(CBMPIresultsPt.rulesModerate);
    } else if (rules < 40) {
      text.push(CBMPIresultsPt.rulesLow);
    }
    if (abstraction > 60) {
      text.push(CBMPIresultsPt.abstractionHigh);
    } else if (abstraction <= 60 && abstraction >= 40) {
      text.push(CBMPIresultsPt.abstractionModerate);
    } else if (abstraction < 40) {
      text.push(CBMPIresultsPt.abstractionLow);
    }
    if (flexibility > 60) {
      text.push(CBMPIresultsPt.flexibilityHigh);
    } else if (flexibility <= 60 && flexibility >= 40) {
      text.push(CBMPIresultsPt.flexibilityModerate);
    } else if (flexibility < 40) {
      text.push(CBMPIresultsPt.flexibilityLow);
    }

    return text;
  };

  function handleCharacter(trait, p) {
    let character;
    let percentage;
    if (trait === "regras" && p >= 50) {
      character = "Disciplinado";
      percentage = p;
    } else if (trait === "regras" && p < 50) {
      character = "Espontâneo";
      percentage = p - 100;
    } else if (trait === "abstração" && p >= 50) {
      character = "Imaginativo";
      percentage = p;
    } else if (trait === "abstração" && p < 50) {
      character = "Realista";
      percentage = p - 100;
    } else if (trait === "flexibilidade" && p >= 50) {
      character = "Assertivo";
      percentage = p;
    } else if (trait === "flexibilidade" && p < 50) {
      character = "Turbulento";
      percentage = p - 100;
    }
    return `${Math.abs(percentage)}% ${character}`;
  }

  function submmit() {
    let CBMPIReduced = CBMPICheck.map((row) => row.indexOf(true));
    CBMPIReduced = CBMPIReduced.map((item) => item + 1);
    const CBMPIAnswers = new Array(42).fill("");
    for (let index = 0; index < CBMPIReduced.length; index++) {
      CBMPIAnswers[index] = CBMPI[CBMPIReduced[index]]
        ? CBMPI[CBMPIReduced[index]]
        : "";
    }

    function reverseItem(item) {
      if (item === 1) {
        return Number(5);
      } else if (item === 2) {
        return Number(4);
      } else if (item === 3) {
        return Number(3);
      } else if (item === 4) {
        return Number(2);
      } else if (item === 5) {
        return Number(1);
      }
    }

    const emotionality =
      CBMPIReduced[0] +
      CBMPIReduced[6] +
      reverseItem(CBMPIReduced[12]) +
      CBMPIReduced[18] +
      reverseItem(CBMPIReduced[24]) +
      CBMPIReduced[30] +
      reverseItem(CBMPIReduced[36]);
    const activity =
      CBMPIReduced[1] +
      reverseItem(CBMPIReduced[7]) +
      CBMPIReduced[13] +
      reverseItem(CBMPIReduced[19]) +
      CBMPIReduced[25] +
      reverseItem(CBMPIReduced[31]) +
      CBMPIReduced[37];
    const sociability =
      CBMPIReduced[2] +
      reverseItem(CBMPIReduced[8]) +
      CBMPIReduced[14] +
      reverseItem(CBMPIReduced[20]) +
      CBMPIReduced[26] +
      reverseItem(CBMPIReduced[32]) +
      CBMPIReduced[38];
    const ruleFollowing =
      CBMPIReduced[3] +
      reverseItem(CBMPIReduced[9]) +
      CBMPIReduced[15] +
      reverseItem(CBMPIReduced[21]) +
      CBMPIReduced[27] +
      reverseItem(CBMPIReduced[33]) +
      CBMPIReduced[39];
    const cognitiveFlexibility =
      CBMPIReduced[4] +
      CBMPIReduced[10] +
      reverseItem(CBMPIReduced[16]) +
      CBMPIReduced[22] +
      reverseItem(CBMPIReduced[28]) +
      CBMPIReduced[34] +
      reverseItem(CBMPIReduced[40]);
    const psychologicalFlexibility =
      CBMPIReduced[5] +
      reverseItem(CBMPIReduced[11]) +
      CBMPIReduced[17] +
      reverseItem(CBMPIReduced[23]) +
      CBMPIReduced[29] +
      reverseItem(CBMPIReduced[35]) +
      CBMPIReduced[41];

    const personalityTraits = [
      Math.round((emotionality * 100) / 35),
      Math.round((activity * 100) / 35),
      Math.round((sociability * 100) / 35),
      Math.round((ruleFollowing * 100) / 40),
      Math.round((cognitiveFlexibility * 100) / 50),
      Math.round((psychologicalFlexibility * 100) / 50),
    ];

    const updatedUserData = {
      ...userData,
      personalityTraits,
    };

    setUserData(updatedUserData);
    // updateUserFirebase(updatedUserData);
  }

  const finish = () => {
    updateUserFirebase(userData);
    setUserData(userData);
    navigate("/");
  };

  if (userData) {
    return (
      <div className={css.container}>
        <section className={css.gridTop}>
          <i
            className={`material-icons ${css.topbarIcon}`}
            onClick={() => {
              setStep(0);
              navigate("/");
            }}
          >
            close
          </i>
          <div className={css.traitBar}>
            <div
              className={css.traitScore}
              style={{
                marginRight: `${((stepLength - step) * 100) / stepLength}%`,
              }}
            ></div>
          </div>
        </section>
        <section className={css.gridMain}>
          {step === 0 && (
            <div className={css.gridMainContainer}>
              <h3>
                Antes de começarmos a jornada, é importante entender como você
                funciona.
              </h3>
              <p>
                A personalidade é o conjunto de características que moldam como
                você percebe, sente, age e reage. Ela é única — resultado da sua
                biologia, história e escolhas.
              </p>
            </div>
          )}
          {step === 1 && (
            <div className={css.gridMainContainer}>
              <h3> Vamos fazer um questionário.</h3>
              <p>
                A seguir estão listadas várias afirmações sobre como você pode
                se sentir ou se comportar. Marque para cada afirmação a resposta
                que melhor descreve você em uma escala de 1 a 5 pontos, em que:
              </p>
              <ul>
                <li>1 = discordo totalmente.</li>
                <li>2 = discordo um pouco.</li>
                <li>3 = nem concordo, nem discordo.</li>
                <li>4 = concordo um pouco.</li>
                <li>5 = concordo totalmente.</li>
              </ul>
              <p>
                Leia cada item com atenção e marque a resposta que melhor
                corresponde com o seu nível de concordância e discordância. Não
                há respostas certas ou erradas. Descreva-se de forma honesta e
                exponha suas opiniões o mais fielmente possível.
              </p>
              <p>Clique abaixo para iniciar</p>
            </div>
          )}
          <form>
            {CBMPI.map((question, row) => (
              <React.Fragment key={row}>
                {step === row + 2 && (
                  <div className={css.gridMainContainer}>
                    <h3>{question}</h3>

                    <label className={css.confirmation}>
                      discordo totalmente
                      <input
                        type="checkbox"
                        checked={CBMPICheck[row][0]}
                        onChange={() => {
                          handleCheckCBMPI(row, 0);
                        }}
                      />
                      <span className={css.checkmark}></span>
                    </label>
                    <label className={css.confirmation}>
                      discordo
                      <input
                        type="checkbox"
                        checked={CBMPICheck[row][1]}
                        onChange={() => {
                          handleCheckCBMPI(row, 1);
                        }}
                      />
                      <span className={css.checkmark}></span>
                    </label>
                    <label className={css.confirmation}>
                      neutro
                      <input
                        type="checkbox"
                        checked={CBMPICheck[row][2]}
                        onChange={() => {
                          handleCheckCBMPI(row, 2);
                        }}
                      />
                      <span className={css.checkmark}></span>
                    </label>
                    <label className={css.confirmation}>
                      concordo
                      <input
                        type="checkbox"
                        checked={CBMPICheck[row][3]}
                        onChange={() => {
                          handleCheckCBMPI(row, 3);
                        }}
                      />
                      <span className={css.checkmark}></span>
                    </label>
                    <label className={css.confirmation}>
                      concordo totalmente
                      <input
                        type="checkbox"
                        checked={CBMPICheck[row][4]}
                        onChange={() => {
                          handleCheckCBMPI(row, 4);
                        }}
                      />
                      <span className={css.checkmark}></span>
                    </label>
                  </div>
                )}
              </React.Fragment>
            ))}
          </form>
          {step === CBMPI.length + 2 && (
            <div className={css.gridMainContainer}>
              <h1>A seguir está um resumo do seu perfil de personalidade.</h1>
              <p>Você pode se reconhecer totalmente, ou apenas em parte.</p>
              <p>Tudo bem! Esse é só um ponto de partida para a sua jornada.</p>
            </div>
          )}
          {step === CBMPI.length + 3 && (
            <div className={css.profileResult}>
              <strong>Seu Perfil de Personalidade</strong>
              {userData.personalityTraits ? (
                <>
                  <p>Emoção: {userData.personalityTraits[0]}%</p>
                  <div className={css.traitBarTemp}>
                    <div
                      className={css.traitScoreTemp}
                      style={{
                        marginRight: `${userData.personalityTraits[0]}%`,
                      }}
                    ></div>
                  </div>
                  <p>Energia: {userData.personalityTraits[1]}%</p>
                  <div className={css.traitBarTemp}>
                    <div
                      className={css.traitScoreTemp}
                      style={{
                        marginRight: `${userData.personalityTraits[1]}%`,
                      }}
                    ></div>
                  </div>
                  <p>Social: {userData.personalityTraits[2]}%</p>
                  <div className={css.traitBarTemp}>
                    <div
                      className={css.traitScoreTemp}
                      style={{
                        marginRight: `${userData.personalityTraits[2]}%`,
                      }}
                    ></div>
                  </div>
                  <div className={css.traitName}>
                    <p>
                      Regras:{" "}
                      {handleCharacter("regras", userData.personalityTraits[3])}
                    </p>
                  </div>
                  <div className={css.traitBarCar}>
                    <div
                      className={css.traitScoreCar}
                      style={{
                        marginLeft: `${userData.personalityTraits[3]}%`,
                      }}
                    ></div>
                  </div>
                  <div className={css.traitCap}>
                    <p>Disciplinado</p>
                    <p>Espontâneo</p>
                  </div>
                  <div className={css.traitName}>
                    <p>
                      Abstração:{" "}
                      {handleCharacter(
                        "abstração",
                        userData.personalityTraits[4]
                      )}
                    </p>
                  </div>
                  <div className={css.traitBarCar}>
                    <div
                      className={css.traitScoreCar}
                      style={{
                        marginLeft: `${userData.personalityTraits[4]}%`,
                      }}
                    ></div>
                  </div>
                  <div className={css.traitCap}>
                    <p>Imaginativo</p>
                    <p>Realista</p>
                  </div>
                  <div className={css.traitName}>
                    <p>
                      Flexibilidade:{" "}
                      {handleCharacter(
                        "flexibilidade",
                        userData.personalityTraits[5]
                      )}
                    </p>
                  </div>
                  <div className={css.traitBarCar}>
                    <div
                      className={css.traitScoreCar}
                      style={{
                        marginLeft: `${userData.personalityTraits[5]}%`,
                      }}
                    ></div>
                  </div>
                  <div className={css.traitCap}>
                    <p>Assertivo</p>
                    <p>Turbulento</p>
                  </div>
                </>
              ) : (
                <button
                  className="defaultButton"
                  onClick={() =>
                    navigate("/teract/discovering-your-personality")
                  }
                >
                  Questionário de Personalidade
                </button>
              )}
              <button
                className="blueButton"
                onClick={() => setDetailsModal(true)}
              >
                Ver Detalhes
              </button>
            </div>
          )}
          {step === CBMPI.length + 4 && (
            <div className={css.gridMainContainer}>
              <h3>💡 Lembre-se: você não é sua personalidade.</h3>
              <p>
                Ela é apenas uma forma de funcionar no mundo — útil para se
                conhecer melhor, mas não uma prisão.
              </p>
              {/* <p>
                Nos próximos passos, vamos falar sobre seu temperamento, seu
                caráter, e o que realmente importa pra você.
              </p> */}
            </div>
          )}
          {step === CBMPI.length + 5 && (
            <div className={css.gridMainContainer}>
              <h3>
                🌱 Você não começa do zero. Você começa de onde está, com tudo o
                que já é.
              </h3>
              <p>Esse resultado poderá ser acessado na página Perfil.</p>
              <p>Parabéns por dar esse primeiro passo.</p>
            </div>
          )}
        </section>
        <div>
          <section className={css.gridOptions}>
            {step > 0 ? (
              <button
                className={`greenButton ${css.button}`}
                onClick={() => {
                  setStep(step - 1);
                }}
              >
                Anterior
              </button>
            ) : (
              <button className={`greenButton ${css.buttonDisabled}`}>
                Anterior
              </button>
            )}
            {step === stepLength ? (
              <button
                className={`greenButton ${css.button}`}
                onClick={() => {
                  setStep(0);
                  submmit();
                  finish();
                }}
              >
                Finalizar
              </button>
            ) : step === CBMPI.length + 2 ? (
              <button
                className={`greenButton ${css.button}`}
                onClick={() => {
                  setStep(step + 1);
                  submmit();
                }}
              >
                Terminar Questionário
              </button>
            ) : !CBMPICheck[step - 2] ? (
              <button
                className={`greenButton ${css.button}`}
                onClick={() => {
                  setStep(step + 1);
                }}
              >
                Próximo
              </button>
            ) : CBMPICheck[step - 2] && CBMPICheck[step - 2].includes(true) ? (
              <button
                className={`greenButton ${css.button}`}
                onClick={() => {
                  setStep(step + 1);
                }}
              >
                Próximo
              </button>
            ) : (
              <button className={`greenButton ${css.buttonDisabled}`}>
                Próximo
              </button>
            )}
          </section>
        </div>
        {detailsModal && (
          <div className={css.modalContainer}>
            <div className={css.modal}>
              <header className={css.modalHeader}>
                <span
                  onClick={() => setDetailsModal(false)}
                  className={`material-icons ${css.materialIcon} ${css.materialButton}`}
                >
                  close
                </span>
              </header>
              <div className={css.modalBody}>
                <h4>Detalhes do Perfil</h4>

                {handleResult(
                  userData.personalityTraits[0],
                  userData.personalityTraits[1],
                  userData.personalityTraits[2],
                  userData.personalityTraits[3],
                  userData.personalityTraits[4],
                  userData.personalityTraits[4]
                ).map((t, i) => (
                  <>
                    <p>{traitLabels[i]}</p>
                    <p key={i}>{t}</p>
                  </>
                ))}

                <footer className={css.modalFooter}>
                  <button
                    className="defaultButton"
                    onClick={() => {
                      setDetailsModal(false);
                    }}
                  >
                    Cancelar
                  </button>
                </footer>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  } else {
    return <div>Loading...</div>;
  }
};
